import Quill from 'quill'
import './tokenBlot.css'

const EmbedBlot: any = Quill.import('blots/embed')

type Token = {
  label: string
  value: string
}

export default class TokenBlot extends EmbedBlot {
  static blotName = 'token'
  static tagName = 'code'

  static value(domNode: any) {
    return {
      label: domNode.textContent,
      value: domNode.getAttribute('data-value')
    }
  }

  static create(value?: Token) {
    const node = super.create()
    node.innerText = value!.label
    node.setAttribute('class', 'token-blot')
    node.setAttribute('data-value', value!.value)
    node.setAttribute('contenteditable', false)

    return node
  }

  length = () => 1
}

Quill.register(TokenBlot, true)
